export default [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'integer',
    width: 50
  },
  {
    dataField: 'marca',
    caption: 'Marca'
  },
  {
    dataField: 'codigo_externo',
    caption: 'Código Externo'
  },
  {
    dataField: 'sincronizado',
    caption: 'Sincronizado'
  },
  {
    caption: 'Ações',
    cellTemplate: 'acaoCell',
    width: 100
  }
]
